import { render, staticRenderFns } from "./PaymentIntegrations.vue?vue&type=template&id=7c9971e8&scoped=true"
import script from "./PaymentIntegrations.vue?vue&type=script&lang=js"
export * from "./PaymentIntegrations.vue?vue&type=script&lang=js"
import style0 from "./PaymentIntegrations.vue?vue&type=style&index=0&id=7c9971e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9971e8",
  null
  
)

export default component.exports